import workflowsReducer from 'features/workflows/state/workflowsSlice'
import notificationsReducer from 'features/notifications/state/notificationSlice'
import connectionsReducer from 'features/connections/state/connectionsSlice'
import mapsReducer from 'features/maps/state/mapsSlice'
import usersReducer from 'features/users/state/usersSlice'
import accountReducer from 'features/account/state/accountSlice'
import keplerGlReducer from 'features/builder/state/keplerGlSlice'
import builderReducer from 'features/builder/state/builderSlice'
import mapCommentsReducer from 'features/builder/state/mapCommentsSlice'
import appsReducer from 'features/apps/state/appsSlice'
import developersReducer from 'features/developers/state/developersSlice'
import dataExplorerReducer from 'features/data-explorer/state/dataExplorerSlice'
import dataObservatoryReducer from 'features/data-observatory/state/dataObservatorySlice'
import jobsProcessingReducer from 'features/jobs/state/jobsProcessingSlice'
import jobsExportingReducer from 'features/jobs/state/jobsExportingSlice'
import jobsImportingReducer from 'features/jobs/state/jobsImportingSlice'
import hubspotReducer from 'features/hubspot/state/hubspotSlice'
import metricsReducer from 'features/metrics/state/metricsSlice'
import analysisReducer from 'features/analysis/state/analysisSlice'
import onboardingChecklistReducer from 'features/onboarding-checklist/state/onboardingChecklistSlice'
import helpPanelReducer from 'features/help-panel/state/helpPanelSlice'
import homeReducer from 'features/home/state/homeSlice'
import commonReducer from 'features/common/state/commonSlice'
import { createCartoSlice, InitialCartoState, CartoState } from '@carto/react-redux'
import dialogsReducer from 'features/dialogs/state/dialogsSlice'
import { AnyAction, Reducer } from 'redux'

const reducer = {
  workflows: workflowsReducer,
  notifications: notificationsReducer,
  connections: connectionsReducer,
  maps: mapsReducer,
  users: usersReducer,
  keplerGl: keplerGlReducer,
  builder: builderReducer,
  mapComments: mapCommentsReducer,
  account: accountReducer,
  apps: appsReducer,
  developers: developersReducer,
  dataExplorer: dataExplorerReducer,
  dataObservatory: dataObservatoryReducer,
  jobs: jobsProcessingReducer,
  jobsExporting: jobsExportingReducer,
  jobsImporting: jobsImportingReducer,
  hubspot: hubspotReducer,
  carto: createCartoSlice({} as InitialCartoState) as unknown as Reducer<CartoState, AnyAction>,
  metrics: metricsReducer,
  analysis: analysisReducer,
  onboardingChecklist: onboardingChecklistReducer,
  helpPanel: helpPanelReducer,
  home: homeReducer,
  common: commonReducer,
  dialogs: dialogsReducer
}

export default reducer
